export default "__VITE_ASSET__Br8M7rfK__"